"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.fetchLatestInventory = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const inventoryService_1 = require("./service/inventoryService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetchLatestInventory = (0, toolkit_1.createAsyncThunk)("inventory/fetchLatestInventory", (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const inventoryService = new inventoryService_1.InventoryService(Env_1.APIPATHENV);
        const response = yield inventoryService.fetchLatestInventory(payload);
        return response;
    }
    catch (error) {
        throw new Error("Error fetching latest inventory");
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)("inventory/update", (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const inventoryService = new inventoryService_1.InventoryService(Env_1.APIPATHENV);
        const response = yield inventoryService.updateInventory(payload);
        return response;
    }
    catch (error) {
        throw new Error("Error updating inventory");
    }
}));
